const common = {
  state: {},
  actions: {},
  mutations: {}
}

export default common
